// extracted by mini-css-extract-plugin
export default {"globalErrorContainer":"style_globalErrorContainer__qktc8","closeIcon":"style_closeIcon__POdwC"};